import EventOne from "../../features/events/event-one";
import EventTwo from "../../features/events/event-two";

export default function EventGroupOne(props) {
    const { eventos } = props;

    if(eventos.payload.length === 0 ) {
        return (
            <h4>NENHUM EVENTO ENCONTRADO</h4>
        )
    }

    return (
        <div className="event-group grid">
            {eventos.payload.map((item, key) => {
                if (key === 0) {
                    return (
                        <div key={key} className="height-x2 grid-item">
                            <EventOne evento={item} loading={eventos.loading} />
                        </div>
                    )
                } else {
                    return (
                        <div key={key} className="height-x1 grid-item">
                            <EventTwo evento={item} loading={eventos.loading} number={10}/>
                        </div>
                    )
                }
            })}
        </div>
    )
}